export default "__VITE_ASSET__DaKxlu_n__"